// extracted by mini-css-extract-plugin
export var divider = "project-profile-module--divider--GZSda";
export var media = "project-profile-module--media--e3vUD";
export var projectTitle = "project-profile-module--projectTitle--IhPDG";
export var videoContainer = "project-profile-module--videoContainer--TqyTV";